import { Markdown } from '@/components/ui/Markdown';

export interface PreviewDocProps {
  body: string;
  fontClassName?: string;
  title: string;
}

export const PreviewDoc = ({
  body,
  fontClassName = 'font-mono',
  title,
}: PreviewDocProps) => (
  <div
    className={`rounded-md border border-border bg-white p-6 text-base/relaxed text-foreground-document shadow-lg ${fontClassName}`}
  >
    <div className="mb-4 flex items-center justify-between border-b border-zinc-200 pb-3">
      <span className="font-mono text-xs tracking-wider text-zinc-500 uppercase">
        {title}
      </span>
    </div>
    <Markdown content={body} tone="light" />
  </div>
);
